function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 239.12 165.75",
    style: {
      enableBackground: "new 0 0 239.12 165.75"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "home-icon1-g1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M111.22,165.75l118.19,0c0.7,0,1.26-0.57,1.26-1.26v-9.99h1.55c3.8,0,6.89-3.1,6.9-6.89V12.52 C239.1,5.64,233.48,0.02,226.6,0H114.04c-6.89,0.02-12.5,5.64-12.52,12.52V147.6c0,3.8,3.1,6.89,6.89,6.89h1.55v9.99 C109.96,165.18,110.53,165.74,111.22,165.75z M112.49,163.21v-8.72h115.66l0,8.72H112.49z M104.05,12.52 c0.01-5.5,4.49-9.98,9.99-9.99H226.6c5.5,0.01,9.98,4.49,9.99,9.99v21.25H104.05V12.52z M108.41,151.96c-2.4,0-4.36-1.96-4.36-4.36 V36.3h132.54v111.3c0,2.4-1.96,4.36-4.36,4.36H108.41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E39F5C"
    },
    d: "M147.81,11.58h-33.77c-0.52,0-0.95,0.43-0.95,0.95v11.26c0,0.52,0.43,0.95,0.95,0.95h33.77 c0.52,0,0.95-0.42,0.95-0.95V12.52C148.76,12,148.33,11.58,147.81,11.58z M146.87,22.83h-31.88v-9.36h31.88V22.83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E39F5C"
    },
    d: "M164.69,11.38c-3.73,0-6.77,3.04-6.77,6.77c0,3.73,3.04,6.77,6.77,6.77c3.73,0,6.76-3.04,6.77-6.77 C171.46,14.42,168.43,11.38,164.69,11.38z M164.7,22.64C164.7,22.64,164.7,22.64,164.7,22.64c-1.2,0-2.33-0.47-3.17-1.31 c-0.85-0.85-1.31-1.97-1.32-3.17c0-2.47,2.01-4.49,4.48-4.49c2.47,0,4.49,2.01,4.49,4.49C169.18,20.62,167.17,22.63,164.7,22.64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E39F5C"
    },
    d: "M187.2,11.38c-3.73,0-6.77,3.04-6.77,6.77c0,3.73,3.04,6.77,6.77,6.77c3.73,0,6.77-3.04,6.77-6.77 C193.97,14.42,190.94,11.38,187.2,11.38z M187.21,22.64L187.21,22.64c-1.2,0-2.33-0.47-3.17-1.31c-0.85-0.85-1.31-1.97-1.31-3.17 c0-1.2,0.47-2.33,1.31-3.17c0.85-0.85,1.97-1.31,3.17-1.31c2.47,0,4.49,2.02,4.49,4.49C191.69,20.62,189.68,22.63,187.21,22.64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E39F5C"
    },
    d: "M209.72,17.2h-5.63c-0.52,0-0.95,0.42-0.95,0.95c0,0.52,0.42,0.95,0.95,0.95h5.63 c0.52,0,0.95-0.42,0.95-0.95C210.66,17.63,210.24,17.2,209.72,17.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E39F5C"
    },
    d: "M226.6,17.2h-5.63c-0.52,0-0.95,0.42-0.95,0.95c0,0.52,0.42,0.95,0.95,0.95h5.63 c0.52,0,0.95-0.42,0.95-0.95C227.55,17.63,227.12,17.2,226.6,17.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M170.32,135.49c-22.84,0-41.36-18.52-41.36-41.36 s18.52-41.36,41.36-41.36s41.36,18.52,41.36,41.36c0,0,0,0,0,0C211.65,116.96,193.15,135.47,170.32,135.49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1309_00000034795890613449055120000017902529462566627223_",
    style: {
      fill: "#E4A05D"
    },
    d: "M170.32,129.1 c-14.07,0.02-26.77-8.41-32.21-21.38c-0.01-0.03-0.03-0.06-0.04-0.1c-0.02-0.03-0.05-0.16-0.05-0.16l-0.03-0.08 c-7.34-17.84,1.16-38.25,19-45.59c4.22-1.74,8.74-2.63,13.3-2.63h0.18c19.23,0,34.82,15.59,34.82,34.83c0,3.05-0.4,6.09-1.19,9.04 l-0.04,0.14C199.96,118.45,186.13,129.08,170.32,129.1L170.32,129.1z M162.38,103.76c-0.18,0-0.37,0-0.55,0.01 c-6.55,0.28-13.03,1.49-19.23,3.6l-1.82,0.62l0.92,1.69c8.56,15.8,28.31,21.66,44.11,13.09c5.91-3.2,10.68-8.16,13.66-14.18 l2.13-4.29l-4.29,2.12c-3.96,1.96-8.33,2.98-12.75,2.98h-0.16c-0.22,0-0.4,0.01-0.58,0.01c-3.91,0-7.75-1-11.16-2.9 C169.53,104.71,165.99,103.76,162.38,103.76 M162.44,101.37c3.91,0,7.75,1,11.17,2.9c3.13,1.8,6.68,2.74,10.29,2.74 c0.18,0,0.37,0,0.55-0.01l0,0c4.34,0,8.62-1.04,12.48-3.03c1.34-0.61,2.72-1.15,4.12-1.61l0.87-0.29l0.2-0.89 c3.93-17.52-7.08-34.9-24.6-38.84c-2.33-0.52-4.72-0.79-7.11-0.79h-0.08c-17.97-0.02-32.55,14.54-32.57,32.5 c0,3.44,0.54,6.86,1.61,10.14l0.51,1.56l1.55-0.53c6.62-2.27,13.53-3.57,20.52-3.85C162.09,101.37,162.26,101.37,162.44,101.37"
  })), /*#__PURE__*/React.createElement("g", {
    className: "home-icon1-g2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E39F5C"
    },
    d: "M1.51,47.54v-1.68h3.37v1.68H1.51z M1.68,37.81v-1.79l3.01-1.06v1.82L1.68,37.81z M4.69,47.54 V34.96h1.77v12.58H4.69z M6.29,47.54v-1.68h3.03v1.68H6.29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E39F5C"
    },
    d: "M15.94,47.72c-2.86,0-4.29-2.13-4.29-6.38c0-4.37,1.43-6.55,4.29-6.55s4.29,2.18,4.29,6.55 C20.23,45.59,18.8,47.72,15.94,47.72z M15.94,46.09c1.59,0,2.39-1.58,2.39-4.75c0-3.28-0.8-4.92-2.39-4.92s-2.39,1.64-2.39,4.92 C13.55,44.5,14.35,46.09,15.94,46.09z M15.94,42.67c-0.4,0-0.72-0.12-0.96-0.37c-0.25-0.24-0.37-0.57-0.37-0.96 c0-0.4,0.12-0.72,0.37-0.97c0.24-0.24,0.57-0.36,0.96-0.36c0.4,0,0.72,0.12,0.97,0.36s0.36,0.56,0.36,0.97 c0,0.4-0.12,0.72-0.36,0.96C16.67,42.55,16.34,42.67,15.94,42.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E39F5C"
    },
    d: "M22.76,47.54v-1.68h3.37v1.68H22.76z M22.94,37.81v-1.79l3.01-1.06v1.82L22.94,37.81z M25.95,47.54 V34.96h1.77v12.58H25.95z M27.55,47.54v-1.68h3.03v1.68H27.55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E39F5C"
    },
    d: "M33.39,47.54v-1.68h3.37v1.68H33.39z M33.57,37.81v-1.79l3.01-1.06v1.82L33.57,37.81z M36.58,47.54 V34.96h1.77v12.58H36.58z M38.18,47.54v-1.68h3.03v1.68H38.18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E39F5C"
    },
    d: "M47.83,47.72c-2.86,0-4.29-2.13-4.29-6.38c0-4.37,1.43-6.55,4.29-6.55s4.29,2.18,4.29,6.55 C52.12,45.59,50.69,47.72,47.83,47.72z M47.83,46.09c1.59,0,2.39-1.58,2.39-4.75c0-3.28-0.8-4.92-2.39-4.92s-2.39,1.64-2.39,4.92 C45.44,44.5,46.24,46.09,47.83,46.09z M47.83,42.67c-0.4,0-0.72-0.12-0.96-0.37c-0.25-0.24-0.37-0.57-0.37-0.96 c0-0.4,0.12-0.72,0.37-0.97c0.24-0.24,0.57-0.36,0.96-0.36c0.4,0,0.72,0.12,0.97,0.36s0.36,0.56,0.36,0.97 c0,0.4-0.12,0.72-0.36,0.96C48.55,42.55,48.23,42.67,47.83,42.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E39F5C"
    },
    d: "M54.65,47.54v-1.68h3.37v1.68H54.65z M54.83,37.81v-1.79l3.01-1.06v1.82L54.83,37.81z M57.84,47.54 V34.96h1.77v12.58H57.84z M59.43,47.54v-1.68h3.03v1.68H59.43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E39F5C"
    },
    d: "M69.09,47.72c-2.86,0-4.29-2.13-4.29-6.38c0-4.37,1.43-6.55,4.29-6.55s4.29,2.18,4.29,6.55 C73.37,45.59,71.95,47.72,69.09,47.72z M69.09,46.09c1.59,0,2.39-1.58,2.39-4.75c0-3.28-0.8-4.92-2.39-4.92s-2.39,1.64-2.39,4.92 C66.7,44.5,67.49,46.09,69.09,46.09z M69.09,42.67c-0.4,0-0.72-0.12-0.96-0.37c-0.25-0.24-0.37-0.57-0.37-0.96 c0-0.4,0.12-0.72,0.37-0.97c0.24-0.24,0.57-0.36,0.96-0.36c0.4,0,0.72,0.12,0.97,0.36s0.36,0.56,0.36,0.97 c0,0.4-0.12,0.72-0.36,0.96C69.81,42.55,69.49,42.67,69.09,42.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E39F5C"
    },
    d: "M75.91,47.54v-1.68h3.37v1.68H75.91z M76.08,37.81v-1.79l3.01-1.06v1.82L76.08,37.81z M79.1,47.54 V34.96h1.77v12.58H79.1z M80.69,47.54v-1.68h3.03v1.68H80.69z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "home-icon1-g3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E39F5C"
    },
    d: "M37.2,75.72c-2.86,0-4.29-2.13-4.29-6.38c0-4.37,1.43-6.55,4.29-6.55s4.29,2.18,4.29,6.55 C41.49,73.59,40.06,75.72,37.2,75.72z M37.2,74.09c1.59,0,2.39-1.58,2.39-4.75c0-3.28-0.8-4.92-2.39-4.92s-2.39,1.64-2.39,4.92 C34.81,72.5,35.61,74.09,37.2,74.09z M37.2,70.67c-0.4,0-0.72-0.12-0.96-0.37c-0.25-0.24-0.37-0.57-0.37-0.96 c0-0.4,0.12-0.72,0.37-0.97c0.24-0.24,0.57-0.36,0.96-0.36c0.4,0,0.72,0.12,0.97,0.36s0.36,0.56,0.36,0.97 c0,0.4-0.12,0.72-0.36,0.96C37.92,70.55,37.6,70.67,37.2,70.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E39F5C"
    },
    d: "M44.02,75.54v-1.68h3.37v1.68H44.02z M44.2,65.81v-1.79l3.01-1.06v1.82L44.2,65.81z M47.21,75.54 V62.96h1.77v12.58H47.21z M48.8,75.54v-1.68h3.03v1.68H48.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E39F5C"
    },
    d: "M58.46,75.72c-2.86,0-4.29-2.13-4.29-6.38c0-4.37,1.43-6.55,4.29-6.55s4.29,2.18,4.29,6.55 C62.75,73.59,61.32,75.72,58.46,75.72z M58.46,74.09c1.59,0,2.39-1.58,2.39-4.75c0-3.28-0.8-4.92-2.39-4.92s-2.39,1.64-2.39,4.92 C56.07,72.5,56.86,74.09,58.46,74.09z M58.46,70.67c-0.4,0-0.72-0.12-0.96-0.37c-0.25-0.24-0.37-0.57-0.37-0.96 c0-0.4,0.12-0.72,0.37-0.97c0.24-0.24,0.57-0.36,0.96-0.36c0.4,0,0.72,0.12,0.97,0.36s0.36,0.56,0.36,0.97 c0,0.4-0.12,0.72-0.36,0.96C59.18,70.55,58.86,70.67,58.46,70.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E39F5C"
    },
    d: "M65.28,75.54v-1.68h3.37v1.68H65.28z M65.46,65.81v-1.79l3.01-1.06v1.82L65.46,65.81z M68.47,75.54 V62.96h1.77v12.58H68.47z M70.06,75.54v-1.68h3.03v1.68H70.06z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E39F5C"
    },
    d: "M75.91,75.54v-1.68h3.37v1.68H75.91z M76.08,65.81v-1.79l3.01-1.06v1.82L76.08,65.81z M79.1,75.54 V62.96h1.77v12.58H79.1z M80.69,75.54v-1.68h3.03v1.68H80.69z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "home-icon1-g4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E39F5C"
    },
    d: "M26.57,104.38c-2.86,0-4.29-2.13-4.29-6.38c0-4.37,1.43-6.55,4.29-6.55s4.29,2.18,4.29,6.55 C30.86,102.26,29.43,104.38,26.57,104.38z M26.57,102.75c1.59,0,2.39-1.58,2.39-4.75c0-3.28-0.8-4.92-2.39-4.92 s-2.39,1.64-2.39,4.92C24.18,101.17,24.98,102.75,26.57,102.75z M26.57,99.33c-0.4,0-0.72-0.12-0.96-0.37 c-0.25-0.24-0.37-0.57-0.37-0.96c0-0.4,0.12-0.72,0.37-0.96c0.24-0.24,0.57-0.36,0.96-0.36c0.4,0,0.72,0.12,0.97,0.36 s0.36,0.56,0.36,0.96c0,0.4-0.12,0.72-0.36,0.96C27.3,99.21,26.97,99.33,26.57,99.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E39F5C"
    },
    d: "M33.39,104.21v-1.68h3.37v1.68H33.39z M33.57,94.48v-1.79l3.01-1.06v1.82L33.57,94.48z  M36.58,104.21V91.63h1.77v12.58H36.58z M38.18,104.21v-1.68h3.03v1.68H38.18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E39F5C"
    },
    d: "M47.83,104.38c-2.86,0-4.29-2.13-4.29-6.38c0-4.37,1.43-6.55,4.29-6.55s4.29,2.18,4.29,6.55 C52.12,102.26,50.69,104.38,47.83,104.38z M47.83,102.75c1.59,0,2.39-1.58,2.39-4.75c0-3.28-0.8-4.92-2.39-4.92 s-2.39,1.64-2.39,4.92C45.44,101.17,46.24,102.75,47.83,102.75z M47.83,99.33c-0.4,0-0.72-0.12-0.96-0.37 c-0.25-0.24-0.37-0.57-0.37-0.96c0-0.4,0.12-0.72,0.37-0.96c0.24-0.24,0.57-0.36,0.96-0.36c0.4,0,0.72,0.12,0.97,0.36 s0.36,0.56,0.36,0.96c0,0.4-0.12,0.72-0.36,0.96C48.55,99.21,48.23,99.33,47.83,99.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E39F5C"
    },
    d: "M54.65,104.21v-1.68h3.37v1.68H54.65z M54.83,94.48v-1.79l3.01-1.06v1.82L54.83,94.48z  M57.84,104.21V91.63h1.77v12.58H57.84z M59.43,104.21v-1.68h3.03v1.68H59.43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E39F5C"
    },
    d: "M65.28,104.21v-1.68h3.37v1.68H65.28z M65.46,94.48v-1.79l3.01-1.06v1.82L65.46,94.48z  M68.47,104.21V91.63h1.77v12.58H68.47z M70.06,104.21v-1.68h3.03v1.68H70.06z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E39F5C"
    },
    d: "M79.72,104.38c-2.86,0-4.29-2.13-4.29-6.38c0-4.37,1.43-6.55,4.29-6.55S84,93.64,84,98.01 C84,102.26,82.57,104.38,79.72,104.38z M79.72,102.75c1.59,0,2.39-1.58,2.39-4.75c0-3.28-0.8-4.92-2.39-4.92s-2.39,1.64-2.39,4.92 C77.32,101.17,78.12,102.75,79.72,102.75z M79.72,99.33c-0.4,0-0.72-0.12-0.96-0.37c-0.25-0.24-0.37-0.57-0.37-0.96 c0-0.4,0.12-0.72,0.37-0.96c0.24-0.24,0.57-0.36,0.96-0.36c0.4,0,0.72,0.12,0.97,0.36s0.36,0.56,0.36,0.96 c0,0.4-0.12,0.72-0.36,0.96C80.44,99.21,80.12,99.33,79.72,99.33z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "home-icon1-g5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E39F5C"
    },
    d: "M58.46,132.72c-2.86,0-4.29-2.13-4.29-6.38c0-4.37,1.43-6.55,4.29-6.55s4.29,2.18,4.29,6.55 C62.75,130.59,61.32,132.72,58.46,132.72z M58.46,131.09c1.59,0,2.39-1.58,2.39-4.75c0-3.28-0.8-4.92-2.39-4.92 s-2.39,1.64-2.39,4.92C56.07,129.5,56.86,131.09,58.46,131.09z M58.46,127.67c-0.4,0-0.72-0.12-0.96-0.37 c-0.25-0.25-0.37-0.57-0.37-0.96c0-0.4,0.12-0.72,0.37-0.97c0.24-0.24,0.57-0.36,0.96-0.36c0.4,0,0.72,0.12,0.97,0.36 s0.36,0.56,0.36,0.97c0,0.4-0.12,0.72-0.36,0.96S58.86,127.67,58.46,127.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E39F5C"
    },
    d: "M69.09,132.72c-2.86,0-4.29-2.13-4.29-6.38c0-4.37,1.43-6.55,4.29-6.55s4.29,2.18,4.29,6.55 C73.37,130.59,71.95,132.72,69.09,132.72z M69.09,131.09c1.59,0,2.39-1.58,2.39-4.75c0-3.28-0.8-4.92-2.39-4.92 s-2.39,1.64-2.39,4.92C66.7,129.5,67.49,131.09,69.09,131.09z M69.09,127.67c-0.4,0-0.72-0.12-0.96-0.37 c-0.25-0.25-0.37-0.57-0.37-0.96c0-0.4,0.12-0.72,0.37-0.97c0.24-0.24,0.57-0.36,0.96-0.36c0.4,0,0.72,0.12,0.97,0.36 s0.36,0.56,0.36,0.97c0,0.4-0.12,0.72-0.36,0.96S69.49,127.67,69.09,127.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E39F5C"
    },
    d: "M75.91,132.54v-1.68h3.37v1.68H75.91z M76.08,122.81v-1.79l3.01-1.06v1.83L76.08,122.81z  M79.1,132.54v-12.58h1.77v12.58H79.1z M80.69,132.54v-1.68h3.03v1.68H80.69z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon1);
export default __webpack_public_path__ + "static/media/home-icon1.94a632d0.svg";
export { ForwardRef as ReactComponent };